wbApp.controller('ActionCategoriesCtrl', ['$scope', '$modal', '$translate', 'subjectsSvc', 'tenantInfo',
function ($scope, $modal, $translate, subjectsSvc, tenantInfo) {

    $scope.gridSettings = {
        columns: [
            { dataField: 'name', caption: $translate.instant('TXT_LBL_NAME'), dataType: 'string', width: '270px', sortOrder: 'asc' },
            { dataField: 'description', caption: $translate.instant('TXT_LBL_DESCRIPTION'), dataType: 'string' },
        ]
    }

    function setSelectedActionCategory(actionCategory) {
        $scope.selectedActionCategory = actionCategory;
    }

    $scope.$on('refreshData', function (e, data) {
        $scope.actionCategories = subjectsSvc.getAllForActionsAsync(true);
        setSelectedActionCategory(null);
    });

    $scope.actionCategories = subjectsSvc.getAllForActionsAsync(true);

    $scope.ActionCategory = {};

    $scope.onRowSelected = function (data) {
        setSelectedActionCategory(data);
    }

    $scope.onRowEdit = function (data) {
        detailDialogPromise.$promise.then(function () {
            detailDialogPromise.$scope.model = angular.copy(data);
            detailDialogPromise.show();
        });
    }

    $scope.onRowAdd = function () {
        detailDialogPromise.$promise.then(function () {
            detailDialogPromise.$scope.model = subjectsSvc.createNew(2);
            detailDialogPromise.show();
        });
    }

    $scope.onRowDelete = function (data) {
        subjectsSvc.remove(data);
    }

    $scope.tabs = [
    {
        title: 'TXT_DETAIL',
        template: "actions/action-categories-detail-tabs/detail.html"
    }];

    $scope.tabs.activeTab = 0;


    var detailDialogPromise = $modal({
        templateUrl: 'actions/action-categories-detail.html',
        show: false,        
        scope: $scope.$new()
    });

}]);
